import * as React from 'react';
import { Box } from '../../Box/Box.js';
import { Typography } from '../../Typography/Typography.js';

var BottomSheetHeader = /*#__PURE__*/React.memo(function (_ref) {
  var subtitle = _ref.subtitle,
    labelledBy = _ref.labelledBy,
    title = _ref.title,
    describedBy = _ref.describedBy;
  return /*#__PURE__*/React.createElement(Box, {
    py: "24",
    px: "64",
    flexDirection: "column",
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Typography, {
    id: labelledBy,
    variant: "heading-l",
    textColor: "base.default"
  }, title), subtitle && /*#__PURE__*/React.createElement(Typography, {
    id: describedBy,
    variant: "caption-default",
    textColor: "base.default",
    mt: "4"
  }, subtitle));
});

export { BottomSheetHeader };
//# sourceMappingURL=BottomSheetHeader.js.map
